"use client";

import { usePathname } from "next/navigation";
import Breadcrumbs from "../sub-atom/Breadcrumbs";
import generateBreadCrumbs from "@/functions/generateBreadCrumbs";

export default function Crumbs({ router }) {
  const defaultRouter = usePathname();
  router = !router ? defaultRouter : router;
  const breadcrumbs = generateBreadCrumbs({
    router,
  });
  return (
    <div className='w-full overflow-hidden overflow-x-scroll'>
      <Breadcrumbs
        datas={breadcrumbs?.map((val) => {
          let sata = val?.title?.split(" ");
          val?.uri?.includes?.("/products/") && sata?.pop();

          val.title = sata?.join(" ");
          return val;
        })}
      />
    </div>
  );
}
